import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getNotificationsAll = createAsyncThunk('getnotificationStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingNotiDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllNotificationsAdmin`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(NotiDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(NotiDetailClear())
                message.error(error) 
            })
    }
)




const GetNotiApiSlice = createSlice({
    name: 'Notigetapi',
    initialState: {
        notifData: null,
        loadingnotif: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
        },
    },
    reducers: {
        gettingNotiDetail: state => {
            state.loadingnotif=true
            state.notifData=null
        },
        NotiDetailResponse: (state, action)=>{
            state.notifData= action.payload
            state.loadingnotif= false
        },
        NotiDetailClear: (state)=>{
            state.notifData= null
            state.loadingnotif= false
        },
        changeNotiDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
    },
})
export const { 
    gettingNotiDetail, NotiDetailResponse, NotiDetailClear,
    changeNotiDetailFilters, setPages
} = GetNotiApiSlice.actions;
export default GetNotiApiSlice.reducer;